import { render } from "./EditDetail.vue?vue&type=template&id=aebab77a&scoped=true"
import script from "./EditDetail.vue?vue&type=script&lang=js"
export * from "./EditDetail.vue?vue&type=script&lang=js"

import "./EditDetail.vue?vue&type=style&index=0&id=aebab77a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aebab77a"

export default script